import React from "react"


function TableBody({
  page,
  getTableBodyProps,
  headerGroups,
  prepareRow,
}) {
  return (
    <>
      <tbody {...getTableBodyProps()}>
        {((page || []).length > 0 &&
          (page || []).map(row => {
            prepareRow(row)
            return (
              <React.Fragment key={row.getRowProps().key}>
                <tr
                  {...row.getRowProps()}
                >
                  {row.cells.map(cell => {
                    return (
                      <td
                        key={cell.id}
                        data-label={cell.column.Header}
                      >
                        {cell.render("Cell")}
                      </td>
                    )
                  })}
                </tr>
              </React.Fragment>
            )
          })) || (
            <tr>
              <td
                colSpan={headerGroups[0]?.headers?.length}
                className="react-bs-table-no-data p-5 text-center"
              >
                Sorry, There are no data to display
              </td>
            </tr>
          )}
      </tbody>
    </>
  )
}

export default TableBody
